import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import {useNavigate } from 'react-router-dom';
import ViewWarehouse from '../../../../component/b2c/models/ViewWarehouse';
import { useMyContext } from '../../../../context/MyContext';
import Swal from 'sweetalert2';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../../css/custom-scrollbar.css';
import { LuWarehouse } from "react-icons/lu";
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { Base_Url, deletewarehouse, Warehouselist } from '../../../../config/config';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [selectAll, setSelectAll] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const [loadingWarehouseId, setloadingWarehouseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWarehouses()
  }, [page, limit]);


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${Warehouselist}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    // Show SweetAlert confirmation dialog
    setloadingWarehouseId(id);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      // Only proceed with deletion if user confirms
      if (result.isConfirmed) {
        const urldelete = Base_Url + deletewarehouse;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            warehouseId: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            setWarehouses((prevWarehouses) => prevWarehouses.filter(warehouse => warehouse.id !== id));
            setTotalOrders((prev) => prev - 1);

            // Show success message using SweetAlert
            Swal.fire(
              'Deleted!',
              response.data.message || 'Warehouse has been deleted successfully.',
              'success'
            );
          } else {
            // Show error message using SweetAlert
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
          setloadingWarehouseId(null);
        } catch (error) {
          // Show error message using SweetAlert
          Swal.fire(
            'Error!',
            'Error deleting warehouse: ' + error.message,
            'error'
          );
        }
      }
    });
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


   const getFilteredWarehouse = () => {
    if (!searchTerm.trim()) {
      return warehouses;
    }

    const term = searchTerm.toLowerCase();
    return warehouses.filter(warehouse => {
      return (
        // Make sure to handle potential undefined values with optional chaining
        (warehouse.name?.toString().toLowerCase().includes(term)) ||
        (warehouse.phone?.toLowerCase().includes(term)) ||
        (warehouse.id?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayWarehouses = getFilteredWarehouse();


  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                  : {}
              }>
              <Sidebar />
            </div>
          )}

          <div className={`shadow-custom-light overflow-x-hidden ml-4 mt-6 mb-6 mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
            <button onClick={handleNavigation}
              className="text-xl w-full sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px]  sm:w-full flex items-center justify-center">
              <LuWarehouse className="mr-2" size={24} />
              All WareHouses
            </button>
            <div className="mb-8">
              <div className="relative group">
                {/* Hover background glow */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/* Input container */}
                <div className="relative flex items-center bg-white dark:bg-darkmodeColor border-2 border-gray-200 dark:border-gray-700 rounded-xl shadow-sm hover:shadow-md focus-within:shadow-lg focus-within:border-customPurple transition-all duration-300">

                  {/* Search Icon */}
                  <div className="pl-4 pr-3">
                    <CgSearch className="text-gray-400 dark:text-gray-300 transition-colors duration-200 group-focus-within:text-customPurple" size={20} />
                  </div>

                  {/* Input Field */}
                  <input
                    type="text"
                    placeholder="Search by Id / Phone No / Name"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="flex-1 p-4 bg-transparent outline-none dark:text-white text-gray-700 placeholder-gray-400 dark:placeholder-gray-300 text-sm font-medium"
                  />

                  {/* Clear Button */}
                  {searchTerm && (
                    <button
                      onClick={() => handleSearchChange({ target: { value: '' } })}
                      className="mr-4 p-1 text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-red-50 dark:hover:bg-red-900/20"
                    >
                      <span className="sr-only">Clear search</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>


            <div className="overflow-x-auto">
              <table className="min-w-full table-auto overflow-y-auto">
                <thead className='bg-gradient-to-r from-[#0540a6] to-[#0650c4] text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                  <tr>
                    <th className='p-2 text-left font-semibold'>Warehouse ID</th>
                    <th className='p-2 text-left font-semibold'>Name</th>
                    <th className='p-2 text-left font-semibold'>Email</th>
                    <th className='p-2 text-left font-semibold'>Phone</th>
                    <th className='p-2 text-left font-semibold'>City</th>
                    <th className='p-2 text-left font-semibold'>State</th>
                    <th className='p-2 text-left font-semibold'>Country</th>
                    <th className='p-2 text-left font-semibold'>Status</th>
                    <th className='p-2 text-left font-semibold'>Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                  {displayWarehouses.map((warehouse, index) => (
                    <tr
                      key={warehouse.id}
                      className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                        ? 'bg-white dark:bg-darkmodeColor'
                        : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                        }`}
                    >
                      <td className='p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors'>
                        {warehouse.id}
                      </td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.name}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.email}</td>
                      <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>{warehouse.phone}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.city}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.state}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.country}</td>
                      <td className='p-3'>
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${warehouse.status === 'Active'
                          ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                          : warehouse.status === 'Inactive'
                            ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                            : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                          }`}>
                          <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${warehouse.status === 'Active'
                            ? 'bg-green-500 animate-pulse'
                            : warehouse.status === 'Inactive'
                              ? 'bg-white'
                              : 'bg-green-500 dark:bg-green-500'
                            }`}></span>
                          {warehouse.status || 'Active'}
                        </span>
                      </td>
                      <td className='p-2'>
                        <div className='flex items-center gap-1'>
                          <Button
                            onClick={() => handleViewClick(warehouse)}
                            variant="contained"
                            color="primary"
                            size="small"
                            className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                            style={{
                              backgroundColor: '#3b82f6',
                              '&:hover': { backgroundColor: '#2563eb' }
                            }}
                          >
                            <IoMdEye className="text-xs" />
                          </Button>
                          {/* <Button
                            onClick={() => handleViewClick(warehouse.id)}
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                            style={{
                              backgroundColor: '#8b5cf6',
                              '&:hover': { backgroundColor: '#7c3aed' }
                            }}
                          >
                            
                          </Button> */}
                          <Button
                            onClick={() => handleDelete(warehouse.id)}
                            variant="contained"
                            color="error"
                            size="small"
                            disabled={loadingWarehouseId === warehouse.id}
                            className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                            style={{
                              backgroundColor: loadingWarehouseId === warehouse.id ? '#f8d7da' : '#ef4444',
                              color: loadingWarehouseId === warehouse.id ? '#721c24' : 'white',
                              '&:hover': { backgroundColor: loadingWarehouseId === warehouse.id ? '#f8d7da' : '#dc2626' }
                            }}
                          >
                            {loadingWarehouseId === warehouse.id ? (
                              <span className="animate-spin">⏳</span>
                            ) : (
                              <MdDelete className="text-xs" />
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Warehouses: ${totalOrders}`}</span>
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`border rounded p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                  disabled={totalOrders < 10}
                >
                  {totalOrders === 0 ? (
                    <option value={0}>0</option>
                  ) : (
                    <>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={totalOrders}>All</option>
                    </>
                  )}
                </select>

                <Pagination
                  count={Math.ceil(totalOrders / limit)}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination"
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                    />
                  )}
                />
              </div>
            </div>
            {/* <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
              <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Warehouse: ${totalOrders}`}</span>
              <select
                id="limit"
                value={limit}
                onChange={handleLimitChange}
                className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={totalOrders}>All</option>
              </select>
              <Pagination
                count={Math.ceil(totalOrders / limit)}
                page={page}
                onChange={handlePaginationChange}
                variant="outlined"
                shape="rounded"
                className="pagination"
                size="small"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                  />
                )}
              />
            </div> */}
          </div>
        </div>

        <ViewWarehouse isopen={isPopupOpen} onClose={handleClose} warehouse={selectedWarehouse} />
      </div>
    </>
  );
};

export default AllWarehouses;
